/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
import React, { useState, useContext } from 'react';
import moment from 'moment-timezone';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { ReactDatePicker } from '@mummssoftware/common-ui';
import {
  formatDateMMDDYY,
  formatPimDate,
} from '@mummssoftware/utils/formatters';
import { isSameDate } from '@mummssoftware/utils/utils';
import { Deceased } from '@mummssoftware/utils/constants';
import { PNCounterIcon } from '@mummssoftware/global-context/PNCounter';
import { ENTITY_PATIENT_CARE_GIVER } from '@mummssoftware/global-context/PNCounter/constants';
import { BereavementContext } from '../../context';
import {
  CellDiv,
  StyledSpan,
  EditableStyledSpan,
  DropDownCellDiv,
} from '../../components/layout/WrapperDiv';

export const DateCell = React.memo((props: any) => {
  /**
*Bereavement start date:
blank if  Bereavement Level  (Item 3 above) is zero
otherwise defaults to patient death, if patient has died.
Only discharged deceased can set start date
*/

  const { data, patient } = props && props;
  const { updateCareGiver } = useContext(BereavementContext);

  const patientDeath = patient.dateOfDeath;
  const patientDeceased = patient.currentStatus === Deceased;

  const [effDate, setDate] = useState(patientDeath);

  const onChange = (date: Date) => {
    if (date) {
      setDate(date as any);
      if (patientDeceased) {
        if (isSameDate(new Date(patient.dateOfDeath), date)) {
          saveDate(moment.utc(date));
        } else {
          saveDate(date);
        }
      } else {
        saveDate(date);
      }
    }
  };

  const hasStartDate = data && data.bereavedStartDate;

  // non Editable if risk level is 0 or patient is alive
  const nonEditableDate = !patientDeath || (data && data.griefRisk === 0);

  const saveDate = (date: any) => {
    const {
      id,
      patientId,
      patientNumber,
      personId,
      personNumber,
      rank,
      relationship,
      patientRelationTypes,
      cahps,
      notes,
      griefRisk,
    } = data;
    const requestBody = {
      id,
      patientId,
      patientNumber,
      personId,
      personNumber,
      rank,
      relationship,
      patientRelationTypes: JSON.parse(patientRelationTypes),
      griefRisk,
      bereaved: true,
      cahps,
      bereavedStartDate: formatPimDate(date),
      notes,
    };
    updateCareGiver(patientId, id, requestBody);
  };

  return hasStartDate ? (
    <CellDiv>{formatDateMMDDYY(data.bereavedStartDate)}</CellDiv>
  ) : nonEditableDate ? (
    <CellDiv></CellDiv>
  ) : patientDeceased ? (
    <CellDiv>
      <ReactDatePicker
        inputTextAlign="unset"
        popperPosition="fixed"
        popperInset="unset"
        popperTransform="unset"
        selectedDate={effDate}
        onChange={onChange}
        minimumDate={patientDeath}
      />
    </CellDiv>
  ) : (
    <CellDiv></CellDiv>
  );
});

export const DropDownCell = React.memo((props: any) => {
  const { data } = props && props;

  return props.value ? (
    <DropDownCellDiv>
      <StyledSpan>{props.value.griefrisk}</StyledSpan>
    </DropDownCellDiv>
  ) : data ? (
    data.griefRisk !== null ? (
      <DropDownCellDiv>
        <EditableStyledSpan>{data.griefRisk}</EditableStyledSpan>
        <ArrowDropDownIcon />
      </DropDownCellDiv>
    ) : (
      <DropDownCellDiv>
        <EditableStyledSpan>?</EditableStyledSpan>
        <ArrowDropDownIcon />
      </DropDownCellDiv>
    )
  ) : (
    <DropDownCellDiv>
      <EditableStyledSpan>?</EditableStyledSpan>
    </DropDownCellDiv>
  );
});

export const NoteCountCellRenderer = (props: any) => (
  /* eslint camelcase: ["error", {allow: ["role_group_name"]}] */
  <PNCounterIcon
    patientNumber={props?.data?.patientNumber}
    entityKey={props?.data?.id.toString()}
    entityName="bereavement"
    entityType={ENTITY_PATIENT_CARE_GIVER}
  />
);
